import { render, staticRenderFns } from "./List-Shipment-Bag.vue?vue&type=template&id=ea7283dc"
import script from "./List-Shipment-Bag.vue?vue&type=script&lang=js"
export * from "./List-Shipment-Bag.vue?vue&type=script&lang=js"
import style0 from "./List-Shipment-Bag.vue?vue&type=style&index=0&id=ea7283dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports